/* eslint-disable import/named */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-var */
/* eslint-disable vars-on-top */
/* eslint-disable prefer-const */
/* eslint-disable no-unused-vars */
/* eslint-disable eqeqeq */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
import React, { useRef, useState } from "react";
import { AiOutlineWarning } from "react-icons/ai";
import { IoNotificationsCircleSharp } from "react-icons/io5";
import { FaUserCircle } from "react-icons/fa";
import { BsFillCaretDownFill } from "react-icons/bs";
import moment from 'moment';
/* eslint-disable no-unused-vars */
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import MenuIcon from "@mui/icons-material/Menu";
import {useSelector, useDispatch } from 'react-redux'
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import logo from "../../../assets/images/tata_motors_logo.png";
import logo2 from "../../../assets/images/logo.png";
import Esakha from "../../../assets/images/esakha.svg";
import styles from "./Header.module.css";
import config from "../../../config/config";
import { ENV_TYPES } from "../../../constants";
import UserProfile from "../../UserProfile/UserProfile";
import { IconButton,Button } from "../../../atomicComponents";
import { useAuthorizationContext } from '../../../providers/AuthorizationHandler/AuthorizationHandler';
import { azureLogout, handleLogout } from "../../../utils/utils";

const Header = (props) => {
  const [showProfile, setShowProfile] = useState(false);
  const profileRef = useRef(null);
  const { openClosee, displayDrawer } = props;
  const renderTestWaterMark = () => (
    <span className={styles.testTitle}>
      <strong>TEST ENVIRONMENT</strong>
      Changes made here will not impact/influence actual Production
    </span>
  );
  const {baseUrl}= useSelector(state => state.counter);  // useSelector
  const dispatch = useDispatch();
  const { user, logoutUser } = useAuthorizationContext();
  const handleLogOut = async () => {
    try {
      await handleLogout(); 
      sessionStorage.clear();
      window.location.href = `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}/oauth2/v2.0/logout`;
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };
  return (
    <div className={styles.header} {...props}  style={{ paddingLeft:displayDrawer == "mobile"?"30px":"8px"}}>
      <div className={styles.leftContainer}>
        {displayDrawer == "mobile" && user?.userName && (
          <div className={styles.mobileIcon}>
            <MenuIcon style={{ color: "#2162ac" }} onClick={openClosee} />
          </div>
        )}
        <img className={styles.logo} src={logo2} alt="Tata Motors" /> 
         {/* <span className={styles.spanClass}>TMCV Engineering Time Tracker</span> */}
         <span className={styles.spanClass}>Engineering Time Tracker</span>

      </div>
      {/* <div>{config.ENV_TYPE === ENV_TYPES.TEST && renderTestWaterMark()}</div> */}
      <div className={styles.rightContainer}>
      {user?.personNumber &&
      <>
       <div className={styles.details}>
        <span className={styles.name}>{user?.userName}</span>
      </div>
       <div className={styles.details}>
          <PersonOutlineOutlinedIcon className={styles.personIcon} />
        </div>
        <div className={styles.iconContainer}>    
          <PowerSettingsNewIcon  onClick={handleLogOut} className={styles.personIcons}  />
        </div>
      </>}
        <div className={styles.esakhaContainer}>
          {/* <a href={config.HOME_UI_BASE_URL} className={styles.homeLink}> */}
            <span>
              <img src={logo} className={styles.esakhaLogo} alt="IMPS 4.0" />
            </span>
          {/* </a> */}
        </div>
      </div>
      {/* <div className={styles.display}>
      
      </div> */}
       
      {/* <UserProfile
        open={showProfile}
        anchorEl={profileRef.current}
        handleClose={() => setShowProfile(false)}
      /> */}

    </div>
  );
};

Header.propTypes = {};

export default Header;
